import React, { Component } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import LoadingOverlay from 'react-loading-overlay';

// import { renderRoutes } from 'react-router-config';
import './App.scss';

import auth from './services/auth';

// Containers
const DefaultLayout = React.lazy(() => import('./containers/DefaultLayout'));

// Pages
const FrontendLogin = React.lazy(() => import('./views/Frontend/Login/Login'));
const BackendLogin = React.lazy(() => import('./views/Backend/Login/Login'));
const Page404 = React.lazy(() => import('./views/Pages/Page404'));
const Page500 = React.lazy(() => import('./views/Pages/Page500'));

const loading = () => 
<LoadingOverlay
  active={true}
  spinner
  text='Loading your content...' />;

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataLoaded: false,
      authenStatus: null,
    };
    this.authService = new auth(this);
  }

  componentDidMount() {
    this.authService.isLoggedIn();
  }

  render() {
    return this.state.dataLoaded ?
      (
        <BrowserRouter forceRefresh={true}>
          <React.Suspense fallback={loading()}>
            <Switch>
              <Route exact path="/404" name="Page 404" render={props => <Page404 {...props} />} />
              <Route exact path="/500" name="Page 500" render={props => <Page500 {...props} />} />

              <Route exact path="/frontend/login" name="Login Page"
                render={props => this.state.authenStatus.isLoggedIn === false ?
                  <FrontendLogin {...props} /> :
                  <Redirect to={{ pathname: '/' + this.state.authenStatus.loggedInSystem + '/requests' }} />
                }
              />

              <Route exact path="/backend/login" name="Login Page"
                render={props => this.state.authenStatus.isLoggedIn === false ?
                  <BackendLogin {...props} /> :
                  <Redirect to={{ pathname: '/' + this.state.authenStatus.loggedInSystem + '/requests' }} />
                }
              />

              <Route path="/" name="Home"
                render={props => this.state.authenStatus.isLoggedIn ?
                  <DefaultLayout {...props} authenStatus={this.state.authenStatus} /> :
                  <Redirect to={{ pathname: '/frontend/login' }} />
                }
              />
            </Switch>
          </React.Suspense>
        </BrowserRouter>
      ) : null;
  }
}

export default App;
